import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { CentralisationMetadataComponentAbstract } from '../../metadata-components/centralisation-metadata/centralisation-metadata.component.abstract';

@Component({
  selector: 'app-centralisation-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './centralisation-metadata-v2.component.html',
  styleUrls: ['./centralisation-metadata-v2.component.css'],
})
export class CentralisationMetadataV2Component extends CentralisationMetadataComponentAbstract {}
